export default "__VITE_ASSET__STQAczlp__"